"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableStyleParagraphPropertiesMergerDivId = exports.TableStyleParagraphPropertiesMergerLineSpacingType = exports.TableStyleParagraphPropertiesMergerLineSpacing = exports.TableStyleParagraphPropertiesMergerFirstLineIndentType = exports.TableStyleParagraphPropertiesMergerFirstLineIndent = exports.TableStyleParagraphPropertiesMergerSuppressLineNumbers = exports.TableStyleParagraphPropertiesMergerSuppressHyphenation = exports.TableStyleParagraphPropertiesMergerWidowOrphanControl = exports.TableStyleParagraphPropertiesMergerContextualSpacing = exports.TableStyleParagraphPropertiesMergerBeforeAutoSpacing = exports.TableStyleParagraphPropertiesMergerRightToLeft = exports.TableStyleParagraphPropertiesMergerKeepLinesTogether = exports.TableStyleParagraphPropertiesMergerAfterAutoSpacing = exports.TableStyleParagraphPropertiesMergerPageBreakBefore = exports.TableStyleParagraphPropertiesMergerBetweenBorder = exports.TableStyleParagraphPropertiesMergerBottomBorder = exports.TableStyleParagraphPropertiesMergerRightBorder = exports.TableStyleParagraphPropertiesMergerSpacingBefore = exports.TableStyleParagraphPropertiesMergerLeftBorder = exports.TableStyleParagraphPropertiesMergerSpacingAfter = exports.TableStyleParagraphPropertiesMergerOutlineLevel = exports.TableStyleParagraphPropertiesMergerKeepWithNext = exports.TableStyleParagraphPropertiesMergerTopBorder = exports.TableStyleParagraphPropertiesMergerRightIndent = exports.TableStyleParagraphPropertiesMergerLeftIndent = exports.TableStyleParagraphPropertiesMergerShadingInfo = exports.TableStyleParagraphPropertiesMergerAlignment = exports.TableStyleParagraphPropertiesMerger = void 0;
var tslib_1 = require("tslib");
var paragraph_properties_1 = require("../../paragraph/paragraph-properties");
var table_cell_properties_merger_1 = require("./table-cell-properties-merger");
var table_properties_merger_base_1 = require("./table-properties-merger-base");
var TableStyleParagraphPropertiesMerger = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMerger, _super);
    function TableStyleParagraphPropertiesMerger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMerger.prototype.getContainerFromConditionalStyle = function (condStyle) {
        return condStyle.maskedParagraphProperties;
    };
    TableStyleParagraphPropertiesMerger.prototype.canUseValue = function (props) {
        return !!(props.useValue & this.getPropertyMask());
    };
    TableStyleParagraphPropertiesMerger.prototype.getCondTableStyleFormattingListForThisContainer = function () {
        return table_cell_properties_merger_1.TableCellPropertiesMerger.conditionalTableStyleFormattingPriority;
    };
    TableStyleParagraphPropertiesMerger.prototype.actionBeforeDefaultValue = function () {
        this.result = null;
        return true;
    };
    TableStyleParagraphPropertiesMerger.prototype.getNotMergedProperty = function () {
        return new table_properties_merger_base_1.TableMergerNotMergedPropertyResult(false, null);
    };
    return TableStyleParagraphPropertiesMerger;
}(table_properties_merger_base_1.TablePropertiesMergerBase));
exports.TableStyleParagraphPropertiesMerger = TableStyleParagraphPropertiesMerger;
var TableStyleParagraphPropertiesMergerAlignment = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerAlignment, _super);
    function TableStyleParagraphPropertiesMergerAlignment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerAlignment.prototype.getPropertyFromContainer = function (container) {
        return container.alignment;
    };
    TableStyleParagraphPropertiesMergerAlignment.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseAlignment;
    };
    return TableStyleParagraphPropertiesMergerAlignment;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerAlignment = TableStyleParagraphPropertiesMergerAlignment;
var TableStyleParagraphPropertiesMergerShadingInfo = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerShadingInfo, _super);
    function TableStyleParagraphPropertiesMergerShadingInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerShadingInfo.prototype.getPropertyFromContainer = function (container) {
        return container.shadingInfo;
    };
    TableStyleParagraphPropertiesMergerShadingInfo.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseShadingInfoIndex;
    };
    return TableStyleParagraphPropertiesMergerShadingInfo;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerShadingInfo = TableStyleParagraphPropertiesMergerShadingInfo;
var TableStyleParagraphPropertiesMergerLeftIndent = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerLeftIndent, _super);
    function TableStyleParagraphPropertiesMergerLeftIndent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerLeftIndent.prototype.getPropertyFromContainer = function (container) {
        return container.leftIndent;
    };
    TableStyleParagraphPropertiesMergerLeftIndent.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseLeftIndent;
    };
    return TableStyleParagraphPropertiesMergerLeftIndent;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerLeftIndent = TableStyleParagraphPropertiesMergerLeftIndent;
var TableStyleParagraphPropertiesMergerRightIndent = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerRightIndent, _super);
    function TableStyleParagraphPropertiesMergerRightIndent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerRightIndent.prototype.getPropertyFromContainer = function (container) {
        return container.rightIndent;
    };
    TableStyleParagraphPropertiesMergerRightIndent.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseRightIndent;
    };
    return TableStyleParagraphPropertiesMergerRightIndent;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerRightIndent = TableStyleParagraphPropertiesMergerRightIndent;
var TableStyleParagraphPropertiesMergerTopBorder = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerTopBorder, _super);
    function TableStyleParagraphPropertiesMergerTopBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerTopBorder.prototype.getPropertyFromContainer = function (container) {
        return container.topBorder;
    };
    TableStyleParagraphPropertiesMergerTopBorder.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseTopBorder;
    };
    return TableStyleParagraphPropertiesMergerTopBorder;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerTopBorder = TableStyleParagraphPropertiesMergerTopBorder;
var TableStyleParagraphPropertiesMergerKeepWithNext = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerKeepWithNext, _super);
    function TableStyleParagraphPropertiesMergerKeepWithNext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerKeepWithNext.prototype.getPropertyFromContainer = function (container) {
        return container.keepWithNext;
    };
    TableStyleParagraphPropertiesMergerKeepWithNext.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseKeepWithNext;
    };
    return TableStyleParagraphPropertiesMergerKeepWithNext;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerKeepWithNext = TableStyleParagraphPropertiesMergerKeepWithNext;
var TableStyleParagraphPropertiesMergerOutlineLevel = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerOutlineLevel, _super);
    function TableStyleParagraphPropertiesMergerOutlineLevel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerOutlineLevel.prototype.getPropertyFromContainer = function (container) {
        return container.outlineLevel;
    };
    TableStyleParagraphPropertiesMergerOutlineLevel.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseOutlineLevel;
    };
    return TableStyleParagraphPropertiesMergerOutlineLevel;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerOutlineLevel = TableStyleParagraphPropertiesMergerOutlineLevel;
var TableStyleParagraphPropertiesMergerSpacingAfter = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerSpacingAfter, _super);
    function TableStyleParagraphPropertiesMergerSpacingAfter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerSpacingAfter.prototype.getPropertyFromContainer = function (container) {
        return container.spacingAfter;
    };
    TableStyleParagraphPropertiesMergerSpacingAfter.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseSpacingAfter;
    };
    return TableStyleParagraphPropertiesMergerSpacingAfter;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerSpacingAfter = TableStyleParagraphPropertiesMergerSpacingAfter;
var TableStyleParagraphPropertiesMergerLeftBorder = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerLeftBorder, _super);
    function TableStyleParagraphPropertiesMergerLeftBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerLeftBorder.prototype.getPropertyFromContainer = function (container) {
        return container.leftBorder;
    };
    TableStyleParagraphPropertiesMergerLeftBorder.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseLeftBorder;
    };
    return TableStyleParagraphPropertiesMergerLeftBorder;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerLeftBorder = TableStyleParagraphPropertiesMergerLeftBorder;
var TableStyleParagraphPropertiesMergerSpacingBefore = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerSpacingBefore, _super);
    function TableStyleParagraphPropertiesMergerSpacingBefore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerSpacingBefore.prototype.getPropertyFromContainer = function (container) {
        return container.spacingBefore;
    };
    TableStyleParagraphPropertiesMergerSpacingBefore.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseSpacingBefore;
    };
    return TableStyleParagraphPropertiesMergerSpacingBefore;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerSpacingBefore = TableStyleParagraphPropertiesMergerSpacingBefore;
var TableStyleParagraphPropertiesMergerRightBorder = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerRightBorder, _super);
    function TableStyleParagraphPropertiesMergerRightBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerRightBorder.prototype.getPropertyFromContainer = function (container) {
        return container.rightBorder;
    };
    TableStyleParagraphPropertiesMergerRightBorder.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseRightBorder;
    };
    return TableStyleParagraphPropertiesMergerRightBorder;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerRightBorder = TableStyleParagraphPropertiesMergerRightBorder;
var TableStyleParagraphPropertiesMergerBottomBorder = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerBottomBorder, _super);
    function TableStyleParagraphPropertiesMergerBottomBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerBottomBorder.prototype.getPropertyFromContainer = function (container) {
        return container.bottomBorder;
    };
    TableStyleParagraphPropertiesMergerBottomBorder.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseBottomBorder;
    };
    return TableStyleParagraphPropertiesMergerBottomBorder;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerBottomBorder = TableStyleParagraphPropertiesMergerBottomBorder;
var TableStyleParagraphPropertiesMergerBetweenBorder = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerBetweenBorder, _super);
    function TableStyleParagraphPropertiesMergerBetweenBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerBetweenBorder.prototype.getPropertyFromContainer = function (container) {
        return container.betweenBorder;
    };
    TableStyleParagraphPropertiesMergerBetweenBorder.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseBetweenBorder;
    };
    return TableStyleParagraphPropertiesMergerBetweenBorder;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerBetweenBorder = TableStyleParagraphPropertiesMergerBetweenBorder;
var TableStyleParagraphPropertiesMergerPageBreakBefore = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerPageBreakBefore, _super);
    function TableStyleParagraphPropertiesMergerPageBreakBefore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerPageBreakBefore.prototype.getPropertyFromContainer = function (container) {
        return container.pageBreakBefore;
    };
    TableStyleParagraphPropertiesMergerPageBreakBefore.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UsePageBreakBefore;
    };
    return TableStyleParagraphPropertiesMergerPageBreakBefore;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerPageBreakBefore = TableStyleParagraphPropertiesMergerPageBreakBefore;
var TableStyleParagraphPropertiesMergerAfterAutoSpacing = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerAfterAutoSpacing, _super);
    function TableStyleParagraphPropertiesMergerAfterAutoSpacing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerAfterAutoSpacing.prototype.getPropertyFromContainer = function (container) {
        return container.afterAutoSpacing;
    };
    TableStyleParagraphPropertiesMergerAfterAutoSpacing.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseAfterAutoSpacing;
    };
    return TableStyleParagraphPropertiesMergerAfterAutoSpacing;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerAfterAutoSpacing = TableStyleParagraphPropertiesMergerAfterAutoSpacing;
var TableStyleParagraphPropertiesMergerKeepLinesTogether = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerKeepLinesTogether, _super);
    function TableStyleParagraphPropertiesMergerKeepLinesTogether() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerKeepLinesTogether.prototype.getPropertyFromContainer = function (container) {
        return container.keepLinesTogether;
    };
    TableStyleParagraphPropertiesMergerKeepLinesTogether.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseKeepLinesTogether;
    };
    return TableStyleParagraphPropertiesMergerKeepLinesTogether;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerKeepLinesTogether = TableStyleParagraphPropertiesMergerKeepLinesTogether;
var TableStyleParagraphPropertiesMergerRightToLeft = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerRightToLeft, _super);
    function TableStyleParagraphPropertiesMergerRightToLeft() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerRightToLeft.prototype.getPropertyFromContainer = function (container) {
        return container.rightToLeft;
    };
    TableStyleParagraphPropertiesMergerRightToLeft.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseRightToLeft;
    };
    return TableStyleParagraphPropertiesMergerRightToLeft;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerRightToLeft = TableStyleParagraphPropertiesMergerRightToLeft;
var TableStyleParagraphPropertiesMergerBeforeAutoSpacing = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerBeforeAutoSpacing, _super);
    function TableStyleParagraphPropertiesMergerBeforeAutoSpacing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerBeforeAutoSpacing.prototype.getPropertyFromContainer = function (container) {
        return container.beforeAutoSpacing;
    };
    TableStyleParagraphPropertiesMergerBeforeAutoSpacing.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseBeforeAutoSpacing;
    };
    return TableStyleParagraphPropertiesMergerBeforeAutoSpacing;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerBeforeAutoSpacing = TableStyleParagraphPropertiesMergerBeforeAutoSpacing;
var TableStyleParagraphPropertiesMergerContextualSpacing = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerContextualSpacing, _super);
    function TableStyleParagraphPropertiesMergerContextualSpacing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerContextualSpacing.prototype.getPropertyFromContainer = function (container) {
        return container.contextualSpacing;
    };
    TableStyleParagraphPropertiesMergerContextualSpacing.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseContextualSpacing;
    };
    return TableStyleParagraphPropertiesMergerContextualSpacing;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerContextualSpacing = TableStyleParagraphPropertiesMergerContextualSpacing;
var TableStyleParagraphPropertiesMergerWidowOrphanControl = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerWidowOrphanControl, _super);
    function TableStyleParagraphPropertiesMergerWidowOrphanControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerWidowOrphanControl.prototype.getPropertyFromContainer = function (container) {
        return container.widowOrphanControl;
    };
    TableStyleParagraphPropertiesMergerWidowOrphanControl.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseWidowOrphanControl;
    };
    return TableStyleParagraphPropertiesMergerWidowOrphanControl;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerWidowOrphanControl = TableStyleParagraphPropertiesMergerWidowOrphanControl;
var TableStyleParagraphPropertiesMergerSuppressHyphenation = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerSuppressHyphenation, _super);
    function TableStyleParagraphPropertiesMergerSuppressHyphenation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerSuppressHyphenation.prototype.getPropertyFromContainer = function (container) {
        return container.suppressHyphenation;
    };
    TableStyleParagraphPropertiesMergerSuppressHyphenation.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseSuppressHyphenation;
    };
    return TableStyleParagraphPropertiesMergerSuppressHyphenation;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerSuppressHyphenation = TableStyleParagraphPropertiesMergerSuppressHyphenation;
var TableStyleParagraphPropertiesMergerSuppressLineNumbers = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerSuppressLineNumbers, _super);
    function TableStyleParagraphPropertiesMergerSuppressLineNumbers() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerSuppressLineNumbers.prototype.getPropertyFromContainer = function (container) {
        return container.suppressLineNumbers;
    };
    TableStyleParagraphPropertiesMergerSuppressLineNumbers.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseSuppressLineNumbers;
    };
    return TableStyleParagraphPropertiesMergerSuppressLineNumbers;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerSuppressLineNumbers = TableStyleParagraphPropertiesMergerSuppressLineNumbers;
var TableStyleParagraphPropertiesMergerFirstLineIndent = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerFirstLineIndent, _super);
    function TableStyleParagraphPropertiesMergerFirstLineIndent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerFirstLineIndent.prototype.getPropertyFromContainer = function (container) {
        return container.firstLineIndent;
    };
    TableStyleParagraphPropertiesMergerFirstLineIndent.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseFirstLineIndent;
    };
    return TableStyleParagraphPropertiesMergerFirstLineIndent;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerFirstLineIndent = TableStyleParagraphPropertiesMergerFirstLineIndent;
var TableStyleParagraphPropertiesMergerFirstLineIndentType = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerFirstLineIndentType, _super);
    function TableStyleParagraphPropertiesMergerFirstLineIndentType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerFirstLineIndentType.prototype.getPropertyFromContainer = function (container) {
        return container.firstLineIndentType;
    };
    TableStyleParagraphPropertiesMergerFirstLineIndentType.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseFirstLineIndent;
    };
    return TableStyleParagraphPropertiesMergerFirstLineIndentType;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerFirstLineIndentType = TableStyleParagraphPropertiesMergerFirstLineIndentType;
var TableStyleParagraphPropertiesMergerLineSpacing = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerLineSpacing, _super);
    function TableStyleParagraphPropertiesMergerLineSpacing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerLineSpacing.prototype.getPropertyFromContainer = function (container) {
        return container.lineSpacing;
    };
    TableStyleParagraphPropertiesMergerLineSpacing.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseLineSpacing;
    };
    return TableStyleParagraphPropertiesMergerLineSpacing;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerLineSpacing = TableStyleParagraphPropertiesMergerLineSpacing;
var TableStyleParagraphPropertiesMergerLineSpacingType = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerLineSpacingType, _super);
    function TableStyleParagraphPropertiesMergerLineSpacingType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerLineSpacingType.prototype.getPropertyFromContainer = function (container) {
        return container.lineSpacingType;
    };
    TableStyleParagraphPropertiesMergerLineSpacingType.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseLineSpacing;
    };
    return TableStyleParagraphPropertiesMergerLineSpacingType;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerLineSpacingType = TableStyleParagraphPropertiesMergerLineSpacingType;
var TableStyleParagraphPropertiesMergerDivId = (function (_super) {
    tslib_1.__extends(TableStyleParagraphPropertiesMergerDivId, _super);
    function TableStyleParagraphPropertiesMergerDivId() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleParagraphPropertiesMergerDivId.prototype.getPropertyFromContainer = function (container) {
        return container.divId;
    };
    TableStyleParagraphPropertiesMergerDivId.prototype.getPropertyMask = function () {
        return paragraph_properties_1.ParagraphPropertiesMask.UseDivId;
    };
    return TableStyleParagraphPropertiesMergerDivId;
}(TableStyleParagraphPropertiesMerger));
exports.TableStyleParagraphPropertiesMergerDivId = TableStyleParagraphPropertiesMergerDivId;
